<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-row>
        <b-col>
          <pos-product-list :systemid="3"></pos-product-list>
        </b-col>
      </b-row>
    </b-card>
  </div?>
</template>
<script>
  import Vue from 'vue'
  import PosProductList from './components/PosProductList'
  export default{
    name: 'BhandargharProducts',
    components: {
      'pos-product-list': PosProductList,
    },
    data: function() {
      return {
      }
    },
    methods: {},
    created: function(){},
  }

</script>
